import React, { lazy } from 'react';

import { ServiceNotAvailableState } from '@lumapps/lumx-states/components/ServiceNotAvailableState';
import { LoadingState } from '@lumapps/micro-apps/components/AdaptiveCard/LoadingState';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { FileListSettingsProps } from './FileListSettings';

const LazyFileListSettings = lazy(
    () =>
        import(
            /* webpackChunkName: 'file-list-lumapps-component-settings' */
            './FileListSettings'
        ),
);

/**
 * FileListSettings component is a wrapper around the lazy loaded FileListSettings component.
 * It renders a loading state while the component is loading and a service not available state if the component fails to load.
 */
export const FileListSettings: React.FC<FileListSettingsProps> = (props) => (
    <Suspense loadingFallback={<LoadingState />} errorFallback={<ServiceNotAvailableState />}>
        <LazyFileListSettings {...props} />
    </Suspense>
);
